import React from 'react';
import { ImageCirlceView, ImageCirlceViewApproved } from '../styles/ImageWrapper';
import placeholder_image from '../assests/placeholder_image.png';



export default function CircleImage(props) {
    if (props.isApproved) {
        return <ImageCirlceViewApproved src={props.src} onError={(e) => { e.target.src = placeholder_image }} />
    } else {
        return <ImageCirlceView src={props.src} onError={(e) => { e.target.src = placeholder_image }} />
    }
}